/**
 * File upload constants for the application
 */
export const FILE_UPLOAD_CONSTANTS = Object.freeze({
  SCAN_UPLOAD: {
    DEFAULT_SIZE_LIMIT: '10MB',
    DEFAULT_EXTENSION: '.mxf',
    DEFAULT_SERVER_URL: '/v1/files',
    MAX_PARALLEL_UPLOADS: 4
  },
  GENERAL: {
    DEFAULT_SIZE_LIMIT: '400MB',
    DEFAULT_EXTENSION: 'image/png, image/jpeg, image/jpg',
    DEFAULT_SERVER_URL: '/v1/files'
  }
} as const);


